import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import VoteProject from '@/types/table/voteProject';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface VoteProjectData extends VoteProject {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class VoteProjectController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VoteProjectData>>(
      API_CONTEXT + '/upms/voteProject/list',
      params,
      httpOptions,
    );
  }
  static myList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VoteProjectData>>(
      API_CONTEXT + '/upms/voteProject/myList',
      params,
      httpOptions,
    );
  }
  static myJoinList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<VoteProjectData>>(
      API_CONTEXT + '/upms/voteProject/myJoinList',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<VoteProjectData>(API_CONTEXT + '/upms/voteProject/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/voteProject/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/voteProject/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/voteProject/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/deleteBatch', params, httpOptions);
  }
  static startVote(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/startVote', params, httpOptions);
  }
  static endVote(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/endVote', params, httpOptions);
  }
  static cancelVote(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/cancelVote', params, httpOptions);
  }
  static vote(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/voteProject/vote', params, httpOptions);
  }
  static viewVoteResult(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/voteProject/viewResult', params, httpOptions);
  }
  static viewUserVote(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/voteProject/viewUserVote', params, httpOptions);
  }
}
